<template>
  <div class="offcanvas-body p-0 bg-white">
    <div class="list-group list-group-flush" v-for="(row, index) in notifieds" :key="index" :role="rowRole(row)">
      <notification-talk-area-data :row="row" :unread-checked="unreadChecked" @update="updateIsRead(index)" />
    </div>
    <div v-if="!notifieds.length" class="d-flex justify-content-center p-1">
      <span>通知はありません。</span>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import NotificationTalkAreaData from "@/views/atoms/NotificationTalkAreaData";

export default {
  name: "NotificationTalkAreaBody",
  components: {
    NotificationTalkAreaData,
  },
  props: {
    unreadChecked: {
      type: Boolean,
      default: false,
    },
  },
  computed:{
    ...mapState('talk_notifieds', {
      notifieds: state => state.data.notifieds,
      showNotificationList: state => state.data.is_show,
    }),
    noNotification() {
      if (this.unreadChecked) {
        return this.talkNotifieds.filter(row => row.is_read === false).length === 0;
      } else {
        return this.talkNotifieds.length === 0;
      }
    },
    reset() {
      if (this.talkNotifieds.length === 0) {
        return 0;
      } else {
        return this.talkNotifieds[0].id;
      }
    },
  },
  methods: {
    ...mapMutations('talk_notifieds', [
      'setShowNotificationList',
    ]),
    rowRole(row) {
      return row.id !== undefined ? 'button' : '';
    },
    updateIsRead(index) {
      this.setIsRead(index);
    },
  },
}
</script>